"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Oct 11 2018
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * BindIdsDTOConverter
 *
 * @author RV
 */


var BindIdsDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(BindIdsDTOConverter, _DataObjectConverter_);

  function BindIdsDTOConverter() {
    _classCallCheck(this, BindIdsDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(BindIdsDTOConverter).apply(this, arguments));
  }

  return BindIdsDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.BindIdsDTOConverter = BindIdsDTOConverter;